import { render, staticRenderFns } from "./BasePopUp.vue?vue&type=template&id=166fa01f&scoped=true"
import script from "./BasePopUp.vue?vue&type=script&lang=js"
export * from "./BasePopUp.vue?vue&type=script&lang=js"
import style0 from "./BasePopUp.vue?vue&type=style&index=0&id=166fa01f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166fa01f",
  null
  
)

export default component.exports